<template>
    <div class="automation-wizard-overview-description">
        <AutomationPieces :pieces="template.pieces" />
        <h2 class="automation-wizard-overview-description__title typographies-heading-h2">
            {{ template.title }}
        </h2>
        <p
            class="automation-wizard-overview-description__description typographies-paragraph-medium-regular"
        >
            {{ template.description }}
        </p>
    </div>
</template>

<script>
import AutomationPieces from 'vcomponents/automation/AutomationPieces.vue';

export default {
    components: {
        AutomationPieces,
    },
    props: {
        template: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-overview-description {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-1);
    text-align: center;

    &__title {
        margin: 0;
    }
    &__description {
        margin: 0;
    }
}
</style>
